// removed by extract-text-webpack-plugin
module.exports = {"contact":"_1U-e3","contactHeading":"_1Nams"};


//////////////////
// WEBPACK FOOTER
// ./components/ContactPhone/styles.scss
// module id = 687
// module chunks = 0